module.exports = __webpack_public_path__ + "static/img/login_left.9d6f3b3d.png";